import React from 'react'
import PropTypes from 'prop-types'

import NavigationArrow from 'components/NavigationArrow/NavigationArrow'
import { ARROW_SIZES, ARROW_TYPES } from 'components/NavigationArrow/constants'

import { NAVIGATION_DIRECTION } from '../../constants'

import styles from './Navigation.scss'

export const Navigation = (props) => {
    const {
        disabled,
        disabledLeft,
        disabledRight,
        size,
        onClick,
        onMouseEnter,
        onMouseLeave,
    } = props

    return (
        <div className={styles.base}>
            <div
                className={styles.arrow}
                onMouseEnter={(e) => onMouseEnter && onMouseEnter(e, NAVIGATION_DIRECTION.LEFT)}
                onMouseLeave={(e) => onMouseLeave && onMouseLeave(e, NAVIGATION_DIRECTION.LEFT)}
            >
                <NavigationArrow
                    type={ARROW_TYPES.left}
                    size={size}
                    disabled={disabled || disabledLeft}
                    handleClick={(e) => onClick(e, NAVIGATION_DIRECTION.LEFT)}
                />
            </div>
            <div
                className={styles.arrow}
                onMouseEnter={(e) => onMouseEnter && onMouseEnter(e, NAVIGATION_DIRECTION.RIGHT)}
                onMouseLeave={(e) => onMouseLeave && onMouseLeave(e, NAVIGATION_DIRECTION.RIGHT)}
            >
                <NavigationArrow
                    type={ARROW_TYPES.right}
                    size={size}
                    disabled={disabled || disabledRight}
                    handleClick={(e) => onClick(e, NAVIGATION_DIRECTION.RIGHT)}
                />
            </div>
        </div>
    )
}

Navigation.propTypes = {
    disabled: PropTypes.bool,
    disabledLeft: PropTypes.bool,
    disabledRight: PropTypes.bool,
    size: PropTypes.oneOf(Object.values(ARROW_SIZES)),
    onClick: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
}

Navigation.defaultProps = {
    disabled: false,
    disabledLeft: false,
    disabledRight: false,
    size: ARROW_SIZES.big,
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/components/Navigation/Navigation.jsx